import request from "project-config/services/request/request";

export const NotificationAPI = Object.freeze({
  recordUserSysNotice: (params: IRecordUserSysNoticeParams) => {
    return request.post(
      "/api/rendering/user/notice/recordUserSysNotice",
      params
    );
  },
});

export type IRecordUserSysNoticeParams = {
  sysNoticeId: number;
};
